// extracted by mini-css-extract-plugin
export var navbar = "index-module--navbar--532f4";